module.exports = __webpack_public_path__ + "static/img/temppic.0405dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/temppic.jpg
// module id = fs4O
// module chunks = 4